import './SOCText.css'

import React from 'react'
import { MAX_SOC, HIG_SOC, MID_SOC, LOW_SOC } from "@/services/repository/soc"


export function socClassColor(value: number): string {
    value = Math.abs(value)
    if (value === undefined || value > MAX_SOC) {
        return ''
    }
    if (value > HIG_SOC) {
        return 'soctext-maker-safe-worn'
    }
    if (value > MID_SOC) {
        return 'soctext-maker-normal-worn'
    }
    if (value > LOW_SOC) {
        return 'soctext-maker-warning-worn'
    }
    return 'soctext-maker-danger-worn'
}

interface SOCValueProps {
  value: number;
  children: React.ReactNode;
}

export const SOCText: React.FC<SOCValueProps> = ({ value, children }) => (
  <span className={socClassColor(value)}>
    {children}
  </span>
);